import Head from 'next/head';

interface IFaqSchemaProps {
  faqCategories: {
    faqCategoryTitle: string;
    faqQuestionItem: IQuestionItem[];
  }[];
  title: string;
  description: string;
  publishedDate: string;
  authorName: string;
}

interface IQuestionItem {
  faqQuestion: string;
  faqAnswer: string;
}

interface IQuestionSchemaItem {
  '@type': 'Question';
  name: string;
  acceptedAnswer: {
    '@type': 'Answer';
    text: string;
  };
}

export default function FaqSchema({
  faqCategories,
  title,
  description,
  publishedDate,
  authorName,
}: IFaqSchemaProps) {
  const questions: IQuestionSchemaItem[] = [];
  faqCategories?.map((category) => {
    category.faqQuestionItem.map((question) => {
      const questionItem: IQuestionSchemaItem = {
        '@type': 'Question',
        name: question.faqQuestion,
        acceptedAnswer: {
          '@type': 'Answer',
          text: question.faqAnswer,
        },
      };
      questions.push(questionItem);
    });
  });

  const schemaFaq = {
    '@context': 'http://schema.org',
    '@type': 'FAQPage',
    name: title,
    description: description ?? undefined,
    author: {
      '@type': 'Organization',
      name: authorName,
    },
    datePublished: publishedDate,
    mainEntity: questions,
  };

  return (
    <Head>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaFaq) }}
      />
    </Head>
  );
}
